import { Badge } from '@chakra-ui/react';
import { Lock } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import { iconSize } from '@duke-hq/ui/constants/scalable';

/** A template whose wording stays in code, so this organisation cannot reword it. */
export function LockedBadge(): React.ReactElement {
  return (
    <Badge colorScheme="purple" display="inline-flex" alignItems="center" gap={1}>
      <Lock size={iconSize.xs} />
      <Trans>Set by Duke</Trans>
    </Badge>
  );
}
